import React from 'react';
import { useLocation } from 'react-router-dom';
import LocationDropdown from './LocationDropdown';
import './Navbar.css';

function HeaderIcon({ type }) {
    return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {type === 'pin' ? <><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>
            : type === 'menu' ? <path d="M4 6h16M4 12h16M4 18h16" />
                : type === 'right' ? <path d="m9 6 6 6-6 6" /> : type === 'down' ? <path d="m6 9 6 6 6-6" /> : <path d="m15 6-6 6 6 6" />}
    </svg>;
}

export default function Navbar({ toggleSidebar, isCollapsed, setIsCollapsed, isSidebarOpen }) {
    const { pathname } = useLocation();
    const titles = [
        ['/users', 'Usuarios'], ['/accounting', 'Contabilidad'], ['/account', 'Configuración'], ['/home', 'Panel Principal'],
        ['/athletes', 'Gestión de Atletas'], ['/athlete-', 'Gestión de Atletas'], ['/training', 'Entrenamientos'],
        ['/memberships', 'Membresías'], ['/notifications', 'Notificaciones'], ['/graphics', 'Gráficas'],
        ['/mob/booking', 'Reservas'], ['/mob/biometrics', 'Acceso y biometría'], ['/mob/guest-pass', 'Cortesías'],
        ['/mob/plans', 'Membresías y planes'], ['/mob/config', 'Programación'], ['/mob/admin', 'Reportes'],
    ];
    const title = titles.find(([path]) => pathname.includes(path))?.[1] || 'Panel Principal';
    const firstName = localStorage.getItem('first_name') || 'Admin';
    const lastName = localStorage.getItem('last_name') || '';
    const role = localStorage.getItem('elevva_role');
    const roleName = role === '10' ? 'Administrador' : role === '20' ? 'Entrenador' : 'Usuario';
    return <header className="dashboard-navbar">
        <button type="button" className="navbar-menu-toggle navbar-mobile-toggle" onClick={toggleSidebar} aria-label={isSidebarOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={Boolean(isSidebarOpen)}><HeaderIcon type="menu" /></button>
        <button type="button" className="navbar-menu-toggle navbar-desktop-toggle" onClick={() => setIsCollapsed(!isCollapsed)} aria-label={isCollapsed ? 'Expandir menú' : 'Contraer menú'} aria-expanded={!isCollapsed}><HeaderIcon type={isCollapsed ? 'right' : 'left'} /></button>
        <div className="navbar-title-container"><span className="navbar-subtitle">ELEVVA CORP</span><h1 className="navbar-title">{title}</h1></div>
        <LocationDropdown />
        <div className="navbar-user-profile"><div className="navbar-user-info"><span className="navbar-user-name">{firstName} {lastName}</span><span className="navbar-user-role">{roleName}</span></div><div className="navbar-user-avatar" aria-hidden="true">{firstName.charAt(0)}{lastName.charAt(0)}</div></div>
    </header>;
}
